
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.12 11.747v3.582a1.791 1.791 0 01-1.79 1.791h-1.792a.896.896 0 01-.895-.895v-5.374a.896.896 0 01.895-.895V7.269a4.478 4.478 0 00-8.956 0v2.687a.895.895 0 01.896.895v5.374a.895.895 0 01-.896.895h-1.79A1.791 1.791 0 014 15.33v-3.583a1.791 1.791 0 011.791-1.791V7.269a6.27 6.27 0 1112.538 0v2.687a1.791 1.791 0 011.791 1.791z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.684 20.914c2.051-.03 6.155-1.519 6.155-7.241","stroke":"#fff"}}),_c('circle',{attrs:{"cx":"11.06","cy":"20.733","r":"1.267","fill":"#fff"}})])
          )
        }
      }
    